import { render, staticRenderFns } from "./CapacitacionesPantalla.vue?vue&type=template&id=c17e42ce&"
import script from "./CapacitacionesPantalla.vue?vue&type=script&lang=ts&"
export * from "./CapacitacionesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports